import type { FC } from 'react';
import { useParams } from 'react-router';
import { usePublicMarketAreas } from 'src/apis/storage/use-public-market-areas';
import { usePublicStorageLocations } from 'src/apis/storage/use-public-storage-locations';
import { useStorageLocationDetails } from 'src/apis/storage/use-storage-location-details';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { StorageLocationEditForm } from 'src/pages/storage/locations-new/edit/location-edit-form';
import { storageLocationsDefaultParams } from 'src/pages/storage/locations-new/utils';

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageLocationEdit: FC<Props> = ({ storageServiceRoot }) => {
  const { locationId } = useParams<{ locationId: string }>();

  const storageLocations = usePublicStorageLocations({
    storageServiceRoot,
    params: storageLocationsDefaultParams,
  });

  const storageLocationDetails = useStorageLocationDetails({
    storageLocations,
    locationId,
  });

  const marketAreas = usePublicMarketAreas({
    storageServiceRoot,
  });

  if (
    !storageLocations.response ||
    !storageLocationDetails.response ||
    !marketAreas.response
  ) {
    return <PageSpinner />;
  }

  return (
    <StorageLocationEditForm
      storageLocationDetails={storageLocationDetails}
      marketAreas={marketAreas}
    />
  );
};
